import { ReactNode } from 'react';
import { AnswerButtonVariant, FunnelImage } from 'core/flow/entities';
import { ButtonImage } from './ButtonImage';
import { ButtonOption } from './ButtonOption';

type AnswerButtonProps = {
  image?: FunnelImage;
  onClick: () => void;
  children?: ReactNode;
  variant?: AnswerButtonVariant;
};

export const AnswerButton = ({
  children,
  onClick,
  image,
  variant = AnswerButtonVariant.OPTION,
  ...otherProps
}: AnswerButtonProps) => {
  if (variant === AnswerButtonVariant.IMAGE) {
    return (
      <ButtonImage onClick={onClick} srcImage={image?.src} {...otherProps}>
        {children}
      </ButtonImage>
    );
  }

  return (
    <ButtonOption onClick={onClick} image={image} {...otherProps}>
      {children}
    </ButtonOption>
  );
};
